import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

const NotFound = (props) => (
  <div className={props.className}>
    <Typography variant="h2">Oops!</Typography>
    <Typography>Sorry, an unexpected error has occurred.</Typography>
    <Typography className="Subtitle">The page is not found.</Typography>
  </div>
);

export default styled(NotFound)(
  ({ theme }) => `
  text-align: center;

  .Subtitle {
    color: ${theme.palette.secondary.main};
    font-style: italic;
  }
`,
);
